import { Button, SearchField } from '@forwardflow/ui'
import { FullCalendarContainer } from './FullCalendar'
import Calendar from 'react-calendar'
import { useState } from 'react'
import { Avatar } from 'antd'
import { useAuth } from '@forwardflow/context/AuthContext'
type ValuePiece = Date | null

type Value = ValuePiece | [ValuePiece, ValuePiece]

export const CalendarComponent = () => {
   const [date, onChangeDate] = useState<Value>(new Date())
   const {
      auth: { user },
   } = useAuth()

   return (
      <>
         <div className="flex gap-7 grayscale-[1] blur-[2px]">
            <div className="flex flex-col gap-2 w-96">
               <div className="flex gap-2">
                  <SearchField
                     className="rounded-lg bg-primary/10"
                     placeholder="Filter by Agents"
                  />
                  <div className="w-16 px-2 rounded-lg bg-primary/10 flexc">
                     <Avatar
                        className="text-[18px] shrink-0 lg:text-[24px] w-9 h-9 lg:w-10 lg:h-10 font-medium bg-[#383838]"
                        src={user?.avatar || null}
                     >
                        {user?.firstName?.charAt(0)}
                     </Avatar>
                  </div>
               </div>
               <Calendar
                  className="p-6 bg-primary/10"
                  onChange={onChangeDate}
                  value={date}
               />
               <div className="flex rounded-lg bg-primary/10">
                  <Button className="px-4 py-2 !mt-0 border-none !rounded-lg bg-primary/10 h-14 !w-[84px] shrink-0">
                     All
                  </Button>
                  <Button className="px-4 py-2 !mt-0 bg-transparent border-none !rounded-lg gap-3 h-14">
                     <span className="bg-[#0FF04E] w-[10px] h-[10px] rounded-full"></span>
                     <span>Success</span>
                  </Button>
                  <Button className="px-4 py-2 !mt-0 !rounded-lg border-none bg-transparent gap-3 h-14">
                     <span className="bg-[#FF5185] w-[10px] h-[10px] rounded-full"></span>
                     <span>No result</span>
                  </Button>
               </div>
               <div className="flex rounded-lg bg-primary/10">
                  <Button className="px-4 py-2 !mt-0 border-none !rounded-lg bg-primary/10 h-14 !w-[84px] shrink-0">
                     All
                  </Button>

                  <Button className="px-4 py-2 !mt-0 !rounded-lg border-none bg-transparent gap-3 h-14">
                     <span className="bg-[#999] w-[10px] h-[10px] rounded-full"></span>
                     <span>Pending Update</span>
                  </Button>
               </div>
               <div className="flex rounded-lg bg-primary/10">
                  <Button className="px-4 py-2 !mt-0 border-none !rounded-lg bg-primary/10 h-14 !w-[84px] shrink-0">
                     All
                  </Button>
                  <Button className="px-4 py-2 !mt-0 bg-transparent border-none !rounded-lg gap-3 h-14">
                     <span className="border border-[#FF5185] w-[10px] h-[10px] rounded-full"></span>
                     <span>Missed</span>
                  </Button>
                  <Button className="px-4 py-2 !mt-0 !rounded-lg border-none bg-transparent gap-3 h-14">
                     <span className="border border-white/50 w-[10px] h-[10px] rounded-full"></span>
                     <span>Reschedule</span>
                  </Button>
               </div>
            </div>

            <FullCalendarContainer
               selectedDate={date instanceof Date ? date : undefined}
            />
         </div>
      </>
   )
}
